module.exports = __webpack_public_path__ + "static/media/ArrowUp.82e85bf3.svg";